// Matches the backend ChatSessionDTO on the livechat service.
export interface ChatSession {
  id: number;
  userId: number;
  serviceRegistrationId: number;
  dateOfStartSession?: string;
  dateOfEndSession?: string;
  chatStatus?: string;
  emailProvider: string;
  emailCustomer: string;
  lastMessage?: string;
  userProfile?: any;
}

// Matches the backend Chat entity as returned by /chat/getAllBySession
// and pushed onto /topic/user.{email} by the STOMP broker.
export interface ChatMessage {
  id?: number;
  chatSessionId: string;
  chatMessage: string;
  origin?: string;
  originEmail: string;
  dateOfMessage?: string;
}

// Payload for the /app/chat.sendMessage STOMP destination.
// originEmail is enforced server-side against Principal, but sending it
// keeps the DTO valid at the JSON-binding layer.
export interface SendMessageRequest {
  chatSessionId: string;
  chatMessage: string;
  origin?: string;
  originEmail: string;
}
